import { Button } from "@svea/design-system-components-react";
import { ButtonGroup, Dialog, useText } from "@sveabank/cc-common";

type Props = {
	isOpen: boolean;
	setOpen: (isOpen: boolean) => void;
};

const NonSignatorModal = ({ isOpen, setOpen }: Props) => {
	const [t, texts] = useText();
	return (
		<Dialog
			isOpen={isOpen}
			setOpen={setOpen}
			size="small"
			center
			heading={t(texts.dashboardPage.invalidApplicantModal.title)}
			icon="warning"
		>
			<Dialog.Content>{t(texts.dashboardPage.invalidApplicantModal.body)}</Dialog.Content>
			<Dialog.Footer>
				<ButtonGroup>
					<Button onPress={() => setOpen(false)}>{t(texts.common.close)}</Button>
				</ButtonGroup>
			</Dialog.Footer>
		</Dialog>
	);
};

export default NonSignatorModal;
